export default __webpack_public_path__ + "static/media/1425.3bda7e90.png";